module.exports = __webpack_public_path__ + "static/img/title-banner1-type2.2180dd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/6/title-banner1-type2.png
// module id = /Q7V
// module chunks = 1